import React, { useState, useEffect } from 'react';

// style
import { css } from '@emotion/react';

// modal
import { useModal } from 'react-modal-hook';
import { ModalWrapper, Content, Footer } from '../../assets/styles/components/modal';
import Backdrop from './Backdrop';

// util
import _ from 'lodash';
import { newLineToBr } from '../utils';

export const useAlert = () => {
    const [msg, setMsg] = useState();

    const [show, hide] = useModal(() => {
        const close = () => {
            setMsg(null);
            hide();
        };

        return (
            <>
                <Backdrop onClose={close} />
                <ModalWrapper>
                    <Content css={css`padding: 5rem !important;`}>
                        <div css={css`
                            text-align: center;
                            font-stretch: normal;
                            font-style: normal;
                            line-height: 1.35;
                        `}>
                            {_.isFunction(msg) ? msg() : newLineToBr(msg)}
                        </div>
                    </Content>
                    <Footer>
                        <button onClick={close}>확인</button>
                    </Footer>
                </ModalWrapper>
            </>
        );
    }, [msg]);

    useEffect(() => {
        if (!msg)
            return;

        show();
    }, [msg, show]);

    return setMsg;
}